var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.769 12.3006C15.7797 11.4659 16.0014 10.6475 16.4135 9.92158C16.8255 9.19563 17.4145 8.58569 18.1256 8.14851C17.6738 7.50335 17.0779 6.97241 16.385 6.59786C15.6922 6.22331 14.9216 6.01546 14.1344 5.99083C12.4552 5.81457 10.8272 6.99566 9.97149 6.99566C9.09922 6.99566 7.78172 6.00833 6.36299 6.03752C5.44532 6.06717 4.55097 6.33403 3.76709 6.81208C2.98322 7.29014 2.33654 7.9631 1.89007 8.76539C-0.0439277 12.1138 1.39866 17.0349 3.25127 19.7415C4.17817 21.0668 5.26145 22.5473 6.6789 22.4948C8.06596 22.4372 8.584 21.6103 10.2583 21.6103C11.9171 21.6103 12.4031 22.4948 13.8493 22.4614C15.3377 22.4372 16.2754 21.1302 17.1698 19.7923C17.8358 18.8479 18.3483 17.8042 18.6882 16.6997C17.8235 16.334 17.0856 15.7218 16.5665 14.9395C16.0474 14.1572 15.77 13.2394 15.769 12.3006Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0376 4.21083C13.8491 3.23663 14.2489 1.98445 14.1521 0.720215C12.9123 0.850435 11.767 1.44299 10.9445 2.37982C10.5424 2.83749 10.2344 3.36993 10.0381 3.9467C9.84188 4.52347 9.76124 5.13326 9.8008 5.74121C10.4209 5.7476 11.0344 5.61319 11.5951 5.3481C12.1558 5.08301 12.649 4.69416 13.0376 4.21083Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleLogo);
export default __webpack_public_path__ + "static/media/apple-logo.3d31b499.svg";
export { ForwardRef as ReactComponent };